module.exports = __webpack_public_path__ + "img/送货上门.f07ca62f.svg";